export default __webpack_public_path__ + "media/clock.c67c56e0.svg";